import { render, staticRenderFns } from "./serPackage.vue?vue&type=template&id=9a8cba54&scoped=true&"
import script from "./serPackage.vue?vue&type=script&lang=js&"
export * from "./serPackage.vue?vue&type=script&lang=js&"
import style0 from "./serPackage.vue?vue&type=style&index=0&id=9a8cba54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8cba54",
  null
  
)

export default component.exports